module.exports = __webpack_public_path__ + "media/packs/images/update-icons/upload-ee7bd5ae4fd888d961416f1a83a5cc74.svg";